module.exports = __webpack_public_path__ + "img/ico-ticket-color.f5c348c3.png";